<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex padding-sm align-items-center text-sm justify-content-between catalogo-text"
          >
            Almacén
            <router-link :to="{ name: 'Almacenes' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody v-if="isLoadingPage">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>

          <CCardBody v-else>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value.sync="$v.nombreAlmacen.$model"
                  :isValid="checkIfValid('nombreAlmacen')"
                  label="Nombre del almacén:"
                  placeholder="Nombre..."
                  invalidFeedback="Campo requerido, debe tener al menos 1 caracter y maximo 25 caracteres"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Ubicacion:</label>
                <v-select
                  v-model="ubicacion"
                  :options="ubicaciones"
                  class="margin-multi"
                  :loading="isLoadingCombos"
                  placeholder="Selecciona una ubicación"
                >
                  <template #no-options>
                    Sin resultados.
                  </template>
                </v-select>
                <!-- <CSelect
                  :value.sync="$v.ubicacion.$model"
                  :isValid="checkIfValid('ubicacion')"
                  horizontal
                  :options="ubicaciones"
                  placeholder="Selecciona una ubicación"
                  invalidFeedback="Campo requerido"
                />-->
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Almacenes' }">
              <CButton class="px-4 mx-3 btn-lg" color="danger"
                >Cancelar</CButton
              >
            </router-link>

            <CButton
              @click="addAlmacen()"
              class="px-4 mx-3 btn-lg"
              color="success"
            >
              <div v-if="isLoading">
                <div
                  class="w-100 d-flex justify-content-center align-items-center"
                >
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
              <span v-else>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
      <CModal
        size="sm"
        title="Almacén"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
        >{{ error }}</CModal
      >
    </CRow>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "NuevoAlmacen",

  components: {
    vSelect
  },

  data() {
    return {
      id: this.$route.params.id,
      ubicacion: null,
      nombreAlmacen: "",
      item: {},
      ubicaciones: [],
      isLoading: false,
      isLoadingPage: false,
      isLoadingCombos: false,
      warningModal: false,
      error: "",
      itemModal: { id: "", name: "" }
    };
  },

  mixins: [validationMixin],
  validations: {
    nombreAlmacen: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(25)
    }
  },

  computed: {
    isValidAlmacen() {
      return !this.$v.nombreAlmacen.$invalid;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.updateCombos();
    }
  },

  created() {
    const ubicacionTemplateRaiz = this.$store.dispatch("customHTTP", {
      schema: "ubicaciones",
      filter: {
        where: [
          {
            field: "id",
            value: this.ubicacionRaizValue,
            operator: "="
          },
          {
            field: "payload->suspendido",
            value: false,
            operator: "="
          }
        ]
      },
      order:[{
        field: 'payload->nombre',
        direction: 'asc'
      }]
    });
    const ubicacionTemplateNoRaiz = this.$store.dispatch("customHTTP", {
      schema: "ubicaciones",
      filter: {
        where: [
          {
            field: "payload->pertenece_id",
            value: 0,
            operator: "="
          },
          {
            field: "payload->suspendido",
            value: false,
            operator: "="
          }
        ]
      },
      order:[{
        field: 'payload->nombre',
        direction: 'asc'
      }]
    });
    this.isLoadingPage = true;
    const alm = [
      this.$store.dispatch("customHTTP", {
        schema: "almacenes",
        filter: {
          wherein: [
            {
              field: "payload->ubicacion_id",
              value: [this.ubicacionRaiz]
            }
          ],
          where: [
            {
              field: "id",
              value: this.id,
              operator: "="
            }
          ]
        }
      })
    ];

    if (this.ubicacionRaizValue) {
      alm.push(ubicacionTemplateRaiz);
    } else {
      alm.push(ubicacionTemplateNoRaiz);
    }
    // this.$store
    //   .dispatch("customHTTP", { schema: "ubicaciones" })
    Promise.all(alm)
      .then(([almacen, ubicaciones]) => {
        this.ubicaciones = ubicaciones.data.map(ubicacion => {
          return { value: ubicacion.id, label: ubicacion.payload.nombre };
        });
        this.item = almacen.data;
        this.nombreAlmacen = almacen.data[0].payload.nombre;
        this.ubicacion = almacen.data[0].payload.ubicacion_id;
        this.ubicacion = this.ubicaciones.find(
          ubi => ubi.value == almacen.data[0].payload.ubicacion_id
        );
      })
      .finally(() => (this.isLoadingPage = false));
  },

  methods: {
    addAlmacen() {
      this.validateAlmacen();

      if (this.isValidAlmacen) {
        if (!this.ubicacion) {
          this.error = "El campo ubicación es obligatorio";
          this.warningModal = true;
          return;
        }
        this.isLoading = true;
        this.$store
          .dispatch("customActualizarHTTP", {
            schema: "almacenes",
            id: this.id,
            payload: {
              nombre: this.nombreAlmacen,
              ubicacion_id: this.ubicacion ? this.ubicacion.value : ""
            }
          })
          .then(() => {
            // console.log(res.data);
            this.$router.push({ name: "Almacenes" });
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
          })

          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateAlmacen() {
      this.$v.nombreAlmacen.$touch();
    },
    updateCombos() {
      const ubicacionTemplateRaiz = this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "id",
              value: this.ubicacionRaizValue,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      });
      const ubicacionTemplateNoRaiz = this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->pertenece_id",
              value: 0,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      });
      this.isLoadingCombos = true;
      const alm = [];

      if (this.ubicacionRaizValue) {
        alm.push(ubicacionTemplateRaiz);
      } else {
        alm.push(ubicacionTemplateNoRaiz);
      }
      // this.$store
      //   .dispatch("customHTTP", { schema: "ubicaciones" })
      Promise.all(alm)
        .then(([ubicaciones]) => {
          this.ubicaciones = ubicaciones.data.map(ubicacion => {
            return { value: ubicacion.id, label: ubicacion.payload.nombre };
          });
        })
        .finally(() => (this.isLoadingCombos = false));
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}

@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
